const baseUrl = "Supplementary";

export const supplementaryLoadApplicationFormUrl = (jambRegNumber) =>
	`${baseUrl}/load-supplementary-application-form?regNumber=${jambRegNumber}`;

export const supplementaryPersonalDetailsFormUrl = () =>
	`${baseUrl}/add-or-update-supplementary-application-personal-details-and-programme`;

export const supplementaryOlevelDetailsFormUrl = () =>
	`${baseUrl}/add-or-update-supplementary-application-olevel-details`;

	export const getSupplementaryResultUrl = (jambRegNumber) =>
		`${baseUrl}/get-supplementary-result?jambRegNumber=${jambRegNumber}`;
